import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pr-2"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "truncate"
}
const _hoisted_4 = { key: 1 }

import { ChevronLeftIcon } from "@heroicons/vue/24/solid";
import { PropType, ref } from "vue";
import { useRouter } from "vue-router";
import SidebarDashboardMenu from "@/components/layout/SidebarDashboardMenu.vue";
import { MenuEntry } from "@/types/Sidebar";


export default /*#__PURE__*/_defineComponent({
  __name: 'SidebarDropDownMenuItem',
  props: {
  collapsed: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  item: {
    type: Object as PropType<MenuEntry>,
  },
  isProject: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
},
  emits: ["addNewDashboard"],
  setup(__props, { emit: __emit }) {

const open = ref(false);

const props = __props;

const emit = __emit;
const router = useRouter();

const handleClick = () => {
  if (props?.item?.route && !props.item.isClickable) {
    router.push(props.item.route);
  } else if (
    props?.item?.options &&
    props?.item?.options[0].items &&
    props?.item?.options[0]?.items[0]?.route &&
    !props.item.isClickable
  ) {
    router.push(props?.item?.options[0]?.items[0]?.route);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      type: "button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (open.value = !open.value)),
      id: "project-button-div",
      class: _normalizeClass([
      'group w-full flex items-center px-4 py-2 text-sm font-medium text-gray-400 justify-between gap-2 cursor-pointer',
      props.collapsed && 'justify-center',
      open.value && 'bg-oaiGray-400 pb-0 text-yellow-400',
      __props.item?.current && 'text-yellow-400 bg-oaiGray-400 currentMenuItem',
    ])
    }, [
      _createElementVNode("div", {
        class: "flex items-center gap-3 group-hover:text-yellow-400",
        onClick: handleClick
      }, [
        (_openBlock(), _createBlock(_resolveDynamicComponent(__props.item?.icon), {
          id: "project-button-icon-main",
          class: "h-6 w-6"
        })),
        (!props.collapsed)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(__props.item?.name), 1))
          : _createCommentVNode("", true)
      ]),
      (!__props.collapsed)
        ? (_openBlock(), _createBlock(_unref(ChevronLeftIcon), {
            key: 0,
            id: "project-button-icon-dropdown",
            class: _normalizeClass(['h-5 w-5 group-hover:text-yellow-400', open.value && '-rotate-90']),
            "aria-hidden": "true"
          }, null, 8, ["class"]))
        : _createCommentVNode("", true)
    ], 2),
    (open.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(['pl-5', open.value && 'bg-oaiGray-400'])
        }, [
          (__props.item?.options)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.item?.options, (optionList) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: optionList.title
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(optionList.items, (option) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: option.name,
                        class: "group group-hover:text-yellow-400"
                      }, [
                        (option?.route)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: option.route,
                              class: _normalizeClass([
              option.current ? 'bg-oaiGray-400 text-yellow-400' : 'text-gray-400',
              'flex gap-2 items-center py-2 text-sm group-hover:text-yellow-400',
              props.collapsed && 'justify-center',
            ])
                            }, {
                              default: _withCtx(() => [
                                (!props.collapsed)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(option.name), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1032, ["to", "class"]))
                          : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (__props.isProject)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(SidebarDashboardMenu, {
                  onAddNewDashboard: _cache[1] || (_cache[1] = ($event: any) => (emit('addNewDashboard', $event))),
                  isMobileMenu: ""
                })
              ]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}
}

})